/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as AppRouteRouteImport } from "./routes/app/route"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as PricingRouteImport } from "./routes/pricing"
import { Route as PrivacyRouteImport } from "./routes/privacy"
import { Route as RankRouteImport } from "./routes/rank"
import { Route as TermsRouteImport } from "./routes/terms"
import { Route as AppIndexRouteImport } from "./routes/app/index"
import { Route as AppSplatRouteImport } from "./routes/app/$"
import { Route as AppDashboardRouteImport } from "./routes/app/dashboard"
import { Route as AppForbiddenRouteImport } from "./routes/app/forbidden"
import { Route as AppNodesRouteImport } from "./routes/app/nodes"
import { Route as AppOperatorRouteRouteImport } from "./routes/app/operator/route"
import { Route as AppSettingsRouteImport } from "./routes/app/settings"
import { Route as AppTenantRouteRouteImport } from "./routes/app/tenant/route"
import { Route as AppTrafficRouteImport } from "./routes/app/traffic"
import { Route as MSplatRouteImport } from "./routes/m/$"
import { Route as AppMeCredentialsRouteImport } from "./routes/app/me/credentials"
import { Route as AppMeNodesRouteImport } from "./routes/app/me/nodes"
import { Route as AppMeNotificationsRouteImport } from "./routes/app/me/notifications"
import { Route as AppMeSettingsRouteImport } from "./routes/app/me/settings"
import { Route as AppMeSubscriptionsRouteImport } from "./routes/app/me/subscriptions"
import { Route as AppMeUsageRouteImport } from "./routes/app/me/usage"
import { Route as AppOperatorIndexRouteImport } from "./routes/app/operator/index"
import { Route as AppOperatorAnnouncementsRouteImport } from "./routes/app/operator/announcements"
import { Route as AppOperatorAuditLogsRouteImport } from "./routes/app/operator/audit-logs"
import { Route as AppOperatorCredentialDomainsRouteImport } from "./routes/app/operator/credential-domains"
import { Route as AppOperatorEnrollmentTokensRouteImport } from "./routes/app/operator/enrollment-tokens"
import { Route as AppOperatorExternalResourcesRouteImport } from "./routes/app/operator/external-resources"
import { Route as AppOperatorGrantsRouteImport } from "./routes/app/operator/grants"
import { Route as AppOperatorNodeGroupsRouteImport } from "./routes/app/operator/node-groups"
import { Route as AppOperatorNodeInstancesRouteImport } from "./routes/app/operator/node-instances"
import { Route as AppOperatorNodesRouteImport } from "./routes/app/operator/nodes"
import { Route as AppOperatorPackagesRouteImport } from "./routes/app/operator/packages"
import { Route as AppOperatorTrafficRouteImport } from "./routes/app/operator/traffic"
import { Route as AppOperatorUsersRouteImport } from "./routes/app/operator/users"
import { Route as AppTenantIndexRouteImport } from "./routes/app/tenant/index"
import { Route as AppTenantLinksRouteImport } from "./routes/app/tenant/links"
import { Route as AppTenantNodeGroupsRouteImport } from "./routes/app/tenant/node-groups"
import { Route as AppTenantPackagesRouteImport } from "./routes/app/tenant/packages"
import { Route as AppTenantSubscriptionsRouteImport } from "./routes/app/tenant/subscriptions"
import { Route as AppTenantUsageRouteImport } from "./routes/app/tenant/usage"
import { Route as AppTenantUsersRouteImport } from "./routes/app/tenant/users"
import { Route as AppOperatorRoutingIndexRouteImport } from "./routes/app/operator/routing/index"
import { Route as AppOperatorRoutingGlobalRouteImport } from "./routes/app/operator/routing/global"
import { Route as AppOperatorRoutingRejectListsRouteImport } from "./routes/app/operator/routing/reject-lists"
import { Route as AppOperatorRoutingUsersRouteImport } from "./routes/app/operator/routing/users"
import { Route as AppOperatorServersIndexRouteImport } from "./routes/app/operator/servers/index"
import { Route as AppOperatorServersServerIdRouteImport } from "./routes/app/operator/servers/$serverId"
import { Route as AppOperatorTenantsIndexRouteImport } from "./routes/app/operator/tenants/index"
import { Route as AppOperatorTenantsTenantIdRouteImport } from "./routes/app/operator/tenants/$tenantId"
import { Route as AppOperatorRoutingNodesIndexRouteImport } from "./routes/app/operator/routing/nodes.index"
import { Route as AppOperatorRoutingNodesNodeIdRouteImport } from "./routes/app/operator/routing/nodes.$nodeId"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: "/app",
  path: "/app",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: "/pricing",
  path: "/pricing",
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: "/privacy",
  path: "/privacy",
  getParentRoute: () => rootRouteImport,
} as any)
const RankRoute = RankRouteImport.update({
  id: "/rank",
  path: "/rank",
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: "/terms",
  path: "/terms",
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSplatRoute = AppSplatRouteImport.update({
  id: "/$",
  path: "/$",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppForbiddenRoute = AppForbiddenRouteImport.update({
  id: "/forbidden",
  path: "/forbidden",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppNodesRoute = AppNodesRouteImport.update({
  id: "/nodes",
  path: "/nodes",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOperatorRouteRoute = AppOperatorRouteRouteImport.update({
  id: "/operator",
  path: "/operator",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTenantRouteRoute = AppTenantRouteRouteImport.update({
  id: "/tenant",
  path: "/tenant",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTrafficRoute = AppTrafficRouteImport.update({
  id: "/traffic",
  path: "/traffic",
  getParentRoute: () => AppRouteRoute,
} as any)
const MSplatRoute = MSplatRouteImport.update({
  id: "/m/$",
  path: "/m/$",
  getParentRoute: () => rootRouteImport,
} as any)
const AppMeCredentialsRoute = AppMeCredentialsRouteImport.update({
  id: "/me/credentials",
  path: "/me/credentials",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMeNodesRoute = AppMeNodesRouteImport.update({
  id: "/me/nodes",
  path: "/me/nodes",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMeNotificationsRoute = AppMeNotificationsRouteImport.update({
  id: "/me/notifications",
  path: "/me/notifications",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMeSettingsRoute = AppMeSettingsRouteImport.update({
  id: "/me/settings",
  path: "/me/settings",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMeSubscriptionsRoute = AppMeSubscriptionsRouteImport.update({
  id: "/me/subscriptions",
  path: "/me/subscriptions",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMeUsageRoute = AppMeUsageRouteImport.update({
  id: "/me/usage",
  path: "/me/usage",
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOperatorIndexRoute = AppOperatorIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppOperatorRouteRoute,
} as any)
const AppOperatorAnnouncementsRoute =
  AppOperatorAnnouncementsRouteImport.update({
    id: "/announcements",
    path: "/announcements",
    getParentRoute: () => AppOperatorRouteRoute,
  } as any)
const AppOperatorAuditLogsRoute = AppOperatorAuditLogsRouteImport.update({
  id: "/audit-logs",
  path: "/audit-logs",
  getParentRoute: () => AppOperatorRouteRoute,
} as any)
const AppOperatorCredentialDomainsRoute =
  AppOperatorCredentialDomainsRouteImport.update({
    id: "/credential-domains",
    path: "/credential-domains",
    getParentRoute: () => AppOperatorRouteRoute,
  } as any)
const AppOperatorEnrollmentTokensRoute =
  AppOperatorEnrollmentTokensRouteImport.update({
    id: "/enrollment-tokens",
    path: "/enrollment-tokens",
    getParentRoute: () => AppOperatorRouteRoute,
  } as any)
const AppOperatorExternalResourcesRoute =
  AppOperatorExternalResourcesRouteImport.update({
    id: "/external-resources",
    path: "/external-resources",
    getParentRoute: () => AppOperatorRouteRoute,
  } as any)
const AppOperatorGrantsRoute = AppOperatorGrantsRouteImport.update({
  id: "/grants",
  path: "/grants",
  getParentRoute: () => AppOperatorRouteRoute,
} as any)
const AppOperatorNodeGroupsRoute = AppOperatorNodeGroupsRouteImport.update({
  id: "/node-groups",
  path: "/node-groups",
  getParentRoute: () => AppOperatorRouteRoute,
} as any)
const AppOperatorNodeInstancesRoute =
  AppOperatorNodeInstancesRouteImport.update({
    id: "/node-instances",
    path: "/node-instances",
    getParentRoute: () => AppOperatorRouteRoute,
  } as any)
const AppOperatorNodesRoute = AppOperatorNodesRouteImport.update({
  id: "/nodes",
  path: "/nodes",
  getParentRoute: () => AppOperatorRouteRoute,
} as any)
const AppOperatorPackagesRoute = AppOperatorPackagesRouteImport.update({
  id: "/packages",
  path: "/packages",
  getParentRoute: () => AppOperatorRouteRoute,
} as any)
const AppOperatorTrafficRoute = AppOperatorTrafficRouteImport.update({
  id: "/traffic",
  path: "/traffic",
  getParentRoute: () => AppOperatorRouteRoute,
} as any)
const AppOperatorUsersRoute = AppOperatorUsersRouteImport.update({
  id: "/users",
  path: "/users",
  getParentRoute: () => AppOperatorRouteRoute,
} as any)
const AppTenantIndexRoute = AppTenantIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppTenantRouteRoute,
} as any)
const AppTenantLinksRoute = AppTenantLinksRouteImport.update({
  id: "/links",
  path: "/links",
  getParentRoute: () => AppTenantRouteRoute,
} as any)
const AppTenantNodeGroupsRoute = AppTenantNodeGroupsRouteImport.update({
  id: "/node-groups",
  path: "/node-groups",
  getParentRoute: () => AppTenantRouteRoute,
} as any)
const AppTenantPackagesRoute = AppTenantPackagesRouteImport.update({
  id: "/packages",
  path: "/packages",
  getParentRoute: () => AppTenantRouteRoute,
} as any)
const AppTenantSubscriptionsRoute = AppTenantSubscriptionsRouteImport.update({
  id: "/subscriptions",
  path: "/subscriptions",
  getParentRoute: () => AppTenantRouteRoute,
} as any)
const AppTenantUsageRoute = AppTenantUsageRouteImport.update({
  id: "/usage",
  path: "/usage",
  getParentRoute: () => AppTenantRouteRoute,
} as any)
const AppTenantUsersRoute = AppTenantUsersRouteImport.update({
  id: "/users",
  path: "/users",
  getParentRoute: () => AppTenantRouteRoute,
} as any)
const AppOperatorRoutingIndexRoute = AppOperatorRoutingIndexRouteImport.update({
  id: "/routing/",
  path: "/routing/",
  getParentRoute: () => AppOperatorRouteRoute,
} as any)
const AppOperatorRoutingGlobalRoute =
  AppOperatorRoutingGlobalRouteImport.update({
    id: "/routing/global",
    path: "/routing/global",
    getParentRoute: () => AppOperatorRouteRoute,
  } as any)
const AppOperatorRoutingRejectListsRoute =
  AppOperatorRoutingRejectListsRouteImport.update({
    id: "/routing/reject-lists",
    path: "/routing/reject-lists",
    getParentRoute: () => AppOperatorRouteRoute,
  } as any)
const AppOperatorRoutingUsersRoute = AppOperatorRoutingUsersRouteImport.update({
  id: "/routing/users",
  path: "/routing/users",
  getParentRoute: () => AppOperatorRouteRoute,
} as any)
const AppOperatorServersIndexRoute = AppOperatorServersIndexRouteImport.update({
  id: "/servers/",
  path: "/servers/",
  getParentRoute: () => AppOperatorRouteRoute,
} as any)
const AppOperatorServersServerIdRoute =
  AppOperatorServersServerIdRouteImport.update({
    id: "/servers/$serverId",
    path: "/servers/$serverId",
    getParentRoute: () => AppOperatorRouteRoute,
  } as any)
const AppOperatorTenantsIndexRoute = AppOperatorTenantsIndexRouteImport.update({
  id: "/tenants/",
  path: "/tenants/",
  getParentRoute: () => AppOperatorRouteRoute,
} as any)
const AppOperatorTenantsTenantIdRoute =
  AppOperatorTenantsTenantIdRouteImport.update({
    id: "/tenants/$tenantId",
    path: "/tenants/$tenantId",
    getParentRoute: () => AppOperatorRouteRoute,
  } as any)
const AppOperatorRoutingNodesIndexRoute =
  AppOperatorRoutingNodesIndexRouteImport.update({
    id: "/routing/nodes/",
    path: "/routing/nodes/",
    getParentRoute: () => AppOperatorRouteRoute,
  } as any)
const AppOperatorRoutingNodesNodeIdRoute =
  AppOperatorRoutingNodesNodeIdRouteImport.update({
    id: "/routing/nodes/$nodeId",
    path: "/routing/nodes/$nodeId",
    getParentRoute: () => AppOperatorRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/app": typeof AppRouteRouteWithChildren
  "/login": typeof LoginRoute
  "/pricing": typeof PricingRoute
  "/privacy": typeof PrivacyRoute
  "/rank": typeof RankRoute
  "/terms": typeof TermsRoute
  "/app/operator": typeof AppOperatorRouteRouteWithChildren
  "/app/tenant": typeof AppTenantRouteRouteWithChildren
  "/app/$": typeof AppSplatRoute
  "/app/dashboard": typeof AppDashboardRoute
  "/app/forbidden": typeof AppForbiddenRoute
  "/app/nodes": typeof AppNodesRoute
  "/app/settings": typeof AppSettingsRoute
  "/app/traffic": typeof AppTrafficRoute
  "/m/$": typeof MSplatRoute
  "/app/": typeof AppIndexRoute
  "/app/me/credentials": typeof AppMeCredentialsRoute
  "/app/me/nodes": typeof AppMeNodesRoute
  "/app/me/notifications": typeof AppMeNotificationsRoute
  "/app/me/settings": typeof AppMeSettingsRoute
  "/app/me/subscriptions": typeof AppMeSubscriptionsRoute
  "/app/me/usage": typeof AppMeUsageRoute
  "/app/operator/announcements": typeof AppOperatorAnnouncementsRoute
  "/app/operator/audit-logs": typeof AppOperatorAuditLogsRoute
  "/app/operator/credential-domains": typeof AppOperatorCredentialDomainsRoute
  "/app/operator/enrollment-tokens": typeof AppOperatorEnrollmentTokensRoute
  "/app/operator/external-resources": typeof AppOperatorExternalResourcesRoute
  "/app/operator/grants": typeof AppOperatorGrantsRoute
  "/app/operator/node-groups": typeof AppOperatorNodeGroupsRoute
  "/app/operator/node-instances": typeof AppOperatorNodeInstancesRoute
  "/app/operator/nodes": typeof AppOperatorNodesRoute
  "/app/operator/packages": typeof AppOperatorPackagesRoute
  "/app/operator/traffic": typeof AppOperatorTrafficRoute
  "/app/operator/users": typeof AppOperatorUsersRoute
  "/app/tenant/links": typeof AppTenantLinksRoute
  "/app/tenant/node-groups": typeof AppTenantNodeGroupsRoute
  "/app/tenant/packages": typeof AppTenantPackagesRoute
  "/app/tenant/subscriptions": typeof AppTenantSubscriptionsRoute
  "/app/tenant/usage": typeof AppTenantUsageRoute
  "/app/tenant/users": typeof AppTenantUsersRoute
  "/app/operator/": typeof AppOperatorIndexRoute
  "/app/tenant/": typeof AppTenantIndexRoute
  "/app/operator/routing/global": typeof AppOperatorRoutingGlobalRoute
  "/app/operator/routing/reject-lists": typeof AppOperatorRoutingRejectListsRoute
  "/app/operator/routing/users": typeof AppOperatorRoutingUsersRoute
  "/app/operator/servers/$serverId": typeof AppOperatorServersServerIdRoute
  "/app/operator/tenants/$tenantId": typeof AppOperatorTenantsTenantIdRoute
  "/app/operator/routing/": typeof AppOperatorRoutingIndexRoute
  "/app/operator/servers/": typeof AppOperatorServersIndexRoute
  "/app/operator/tenants/": typeof AppOperatorTenantsIndexRoute
  "/app/operator/routing/nodes/$nodeId": typeof AppOperatorRoutingNodesNodeIdRoute
  "/app/operator/routing/nodes/": typeof AppOperatorRoutingNodesIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/login": typeof LoginRoute
  "/pricing": typeof PricingRoute
  "/privacy": typeof PrivacyRoute
  "/rank": typeof RankRoute
  "/terms": typeof TermsRoute
  "/app/$": typeof AppSplatRoute
  "/app/dashboard": typeof AppDashboardRoute
  "/app/forbidden": typeof AppForbiddenRoute
  "/app/nodes": typeof AppNodesRoute
  "/app/settings": typeof AppSettingsRoute
  "/app/traffic": typeof AppTrafficRoute
  "/m/$": typeof MSplatRoute
  "/app": typeof AppIndexRoute
  "/app/me/credentials": typeof AppMeCredentialsRoute
  "/app/me/nodes": typeof AppMeNodesRoute
  "/app/me/notifications": typeof AppMeNotificationsRoute
  "/app/me/settings": typeof AppMeSettingsRoute
  "/app/me/subscriptions": typeof AppMeSubscriptionsRoute
  "/app/me/usage": typeof AppMeUsageRoute
  "/app/operator/announcements": typeof AppOperatorAnnouncementsRoute
  "/app/operator/audit-logs": typeof AppOperatorAuditLogsRoute
  "/app/operator/credential-domains": typeof AppOperatorCredentialDomainsRoute
  "/app/operator/enrollment-tokens": typeof AppOperatorEnrollmentTokensRoute
  "/app/operator/external-resources": typeof AppOperatorExternalResourcesRoute
  "/app/operator/grants": typeof AppOperatorGrantsRoute
  "/app/operator/node-groups": typeof AppOperatorNodeGroupsRoute
  "/app/operator/node-instances": typeof AppOperatorNodeInstancesRoute
  "/app/operator/nodes": typeof AppOperatorNodesRoute
  "/app/operator/packages": typeof AppOperatorPackagesRoute
  "/app/operator/traffic": typeof AppOperatorTrafficRoute
  "/app/operator/users": typeof AppOperatorUsersRoute
  "/app/tenant/links": typeof AppTenantLinksRoute
  "/app/tenant/node-groups": typeof AppTenantNodeGroupsRoute
  "/app/tenant/packages": typeof AppTenantPackagesRoute
  "/app/tenant/subscriptions": typeof AppTenantSubscriptionsRoute
  "/app/tenant/usage": typeof AppTenantUsageRoute
  "/app/tenant/users": typeof AppTenantUsersRoute
  "/app/operator": typeof AppOperatorIndexRoute
  "/app/tenant": typeof AppTenantIndexRoute
  "/app/operator/routing/global": typeof AppOperatorRoutingGlobalRoute
  "/app/operator/routing/reject-lists": typeof AppOperatorRoutingRejectListsRoute
  "/app/operator/routing/users": typeof AppOperatorRoutingUsersRoute
  "/app/operator/servers/$serverId": typeof AppOperatorServersServerIdRoute
  "/app/operator/tenants/$tenantId": typeof AppOperatorTenantsTenantIdRoute
  "/app/operator/routing": typeof AppOperatorRoutingIndexRoute
  "/app/operator/servers": typeof AppOperatorServersIndexRoute
  "/app/operator/tenants": typeof AppOperatorTenantsIndexRoute
  "/app/operator/routing/nodes/$nodeId": typeof AppOperatorRoutingNodesNodeIdRoute
  "/app/operator/routing/nodes": typeof AppOperatorRoutingNodesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/app": typeof AppRouteRouteWithChildren
  "/login": typeof LoginRoute
  "/pricing": typeof PricingRoute
  "/privacy": typeof PrivacyRoute
  "/rank": typeof RankRoute
  "/terms": typeof TermsRoute
  "/app/operator": typeof AppOperatorRouteRouteWithChildren
  "/app/tenant": typeof AppTenantRouteRouteWithChildren
  "/app/$": typeof AppSplatRoute
  "/app/dashboard": typeof AppDashboardRoute
  "/app/forbidden": typeof AppForbiddenRoute
  "/app/nodes": typeof AppNodesRoute
  "/app/settings": typeof AppSettingsRoute
  "/app/traffic": typeof AppTrafficRoute
  "/m/$": typeof MSplatRoute
  "/app/": typeof AppIndexRoute
  "/app/me/credentials": typeof AppMeCredentialsRoute
  "/app/me/nodes": typeof AppMeNodesRoute
  "/app/me/notifications": typeof AppMeNotificationsRoute
  "/app/me/settings": typeof AppMeSettingsRoute
  "/app/me/subscriptions": typeof AppMeSubscriptionsRoute
  "/app/me/usage": typeof AppMeUsageRoute
  "/app/operator/announcements": typeof AppOperatorAnnouncementsRoute
  "/app/operator/audit-logs": typeof AppOperatorAuditLogsRoute
  "/app/operator/credential-domains": typeof AppOperatorCredentialDomainsRoute
  "/app/operator/enrollment-tokens": typeof AppOperatorEnrollmentTokensRoute
  "/app/operator/external-resources": typeof AppOperatorExternalResourcesRoute
  "/app/operator/grants": typeof AppOperatorGrantsRoute
  "/app/operator/node-groups": typeof AppOperatorNodeGroupsRoute
  "/app/operator/node-instances": typeof AppOperatorNodeInstancesRoute
  "/app/operator/nodes": typeof AppOperatorNodesRoute
  "/app/operator/packages": typeof AppOperatorPackagesRoute
  "/app/operator/traffic": typeof AppOperatorTrafficRoute
  "/app/operator/users": typeof AppOperatorUsersRoute
  "/app/tenant/links": typeof AppTenantLinksRoute
  "/app/tenant/node-groups": typeof AppTenantNodeGroupsRoute
  "/app/tenant/packages": typeof AppTenantPackagesRoute
  "/app/tenant/subscriptions": typeof AppTenantSubscriptionsRoute
  "/app/tenant/usage": typeof AppTenantUsageRoute
  "/app/tenant/users": typeof AppTenantUsersRoute
  "/app/operator/": typeof AppOperatorIndexRoute
  "/app/tenant/": typeof AppTenantIndexRoute
  "/app/operator/routing/global": typeof AppOperatorRoutingGlobalRoute
  "/app/operator/routing/reject-lists": typeof AppOperatorRoutingRejectListsRoute
  "/app/operator/routing/users": typeof AppOperatorRoutingUsersRoute
  "/app/operator/servers/$serverId": typeof AppOperatorServersServerIdRoute
  "/app/operator/tenants/$tenantId": typeof AppOperatorTenantsTenantIdRoute
  "/app/operator/routing/": typeof AppOperatorRoutingIndexRoute
  "/app/operator/servers/": typeof AppOperatorServersIndexRoute
  "/app/operator/tenants/": typeof AppOperatorTenantsIndexRoute
  "/app/operator/routing/nodes/$nodeId": typeof AppOperatorRoutingNodesNodeIdRoute
  "/app/operator/routing/nodes/": typeof AppOperatorRoutingNodesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/app"
    | "/login"
    | "/pricing"
    | "/privacy"
    | "/rank"
    | "/terms"
    | "/app/operator"
    | "/app/tenant"
    | "/app/$"
    | "/app/dashboard"
    | "/app/forbidden"
    | "/app/nodes"
    | "/app/settings"
    | "/app/traffic"
    | "/m/$"
    | "/app/"
    | "/app/me/credentials"
    | "/app/me/nodes"
    | "/app/me/notifications"
    | "/app/me/settings"
    | "/app/me/subscriptions"
    | "/app/me/usage"
    | "/app/operator/announcements"
    | "/app/operator/audit-logs"
    | "/app/operator/credential-domains"
    | "/app/operator/enrollment-tokens"
    | "/app/operator/external-resources"
    | "/app/operator/grants"
    | "/app/operator/node-groups"
    | "/app/operator/node-instances"
    | "/app/operator/nodes"
    | "/app/operator/packages"
    | "/app/operator/traffic"
    | "/app/operator/users"
    | "/app/tenant/links"
    | "/app/tenant/node-groups"
    | "/app/tenant/packages"
    | "/app/tenant/subscriptions"
    | "/app/tenant/usage"
    | "/app/tenant/users"
    | "/app/operator/"
    | "/app/tenant/"
    | "/app/operator/routing/global"
    | "/app/operator/routing/reject-lists"
    | "/app/operator/routing/users"
    | "/app/operator/servers/$serverId"
    | "/app/operator/tenants/$tenantId"
    | "/app/operator/routing/"
    | "/app/operator/servers/"
    | "/app/operator/tenants/"
    | "/app/operator/routing/nodes/$nodeId"
    | "/app/operator/routing/nodes/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/login"
    | "/pricing"
    | "/privacy"
    | "/rank"
    | "/terms"
    | "/app/$"
    | "/app/dashboard"
    | "/app/forbidden"
    | "/app/nodes"
    | "/app/settings"
    | "/app/traffic"
    | "/m/$"
    | "/app"
    | "/app/me/credentials"
    | "/app/me/nodes"
    | "/app/me/notifications"
    | "/app/me/settings"
    | "/app/me/subscriptions"
    | "/app/me/usage"
    | "/app/operator/announcements"
    | "/app/operator/audit-logs"
    | "/app/operator/credential-domains"
    | "/app/operator/enrollment-tokens"
    | "/app/operator/external-resources"
    | "/app/operator/grants"
    | "/app/operator/node-groups"
    | "/app/operator/node-instances"
    | "/app/operator/nodes"
    | "/app/operator/packages"
    | "/app/operator/traffic"
    | "/app/operator/users"
    | "/app/tenant/links"
    | "/app/tenant/node-groups"
    | "/app/tenant/packages"
    | "/app/tenant/subscriptions"
    | "/app/tenant/usage"
    | "/app/tenant/users"
    | "/app/operator"
    | "/app/tenant"
    | "/app/operator/routing/global"
    | "/app/operator/routing/reject-lists"
    | "/app/operator/routing/users"
    | "/app/operator/servers/$serverId"
    | "/app/operator/tenants/$tenantId"
    | "/app/operator/routing"
    | "/app/operator/servers"
    | "/app/operator/tenants"
    | "/app/operator/routing/nodes/$nodeId"
    | "/app/operator/routing/nodes"
  id:
    | "__root__"
    | "/"
    | "/app"
    | "/login"
    | "/pricing"
    | "/privacy"
    | "/rank"
    | "/terms"
    | "/app/operator"
    | "/app/tenant"
    | "/app/$"
    | "/app/dashboard"
    | "/app/forbidden"
    | "/app/nodes"
    | "/app/settings"
    | "/app/traffic"
    | "/m/$"
    | "/app/"
    | "/app/me/credentials"
    | "/app/me/nodes"
    | "/app/me/notifications"
    | "/app/me/settings"
    | "/app/me/subscriptions"
    | "/app/me/usage"
    | "/app/operator/announcements"
    | "/app/operator/audit-logs"
    | "/app/operator/credential-domains"
    | "/app/operator/enrollment-tokens"
    | "/app/operator/external-resources"
    | "/app/operator/grants"
    | "/app/operator/node-groups"
    | "/app/operator/node-instances"
    | "/app/operator/nodes"
    | "/app/operator/packages"
    | "/app/operator/traffic"
    | "/app/operator/users"
    | "/app/tenant/links"
    | "/app/tenant/node-groups"
    | "/app/tenant/packages"
    | "/app/tenant/subscriptions"
    | "/app/tenant/usage"
    | "/app/tenant/users"
    | "/app/operator/"
    | "/app/tenant/"
    | "/app/operator/routing/global"
    | "/app/operator/routing/reject-lists"
    | "/app/operator/routing/users"
    | "/app/operator/servers/$serverId"
    | "/app/operator/tenants/$tenantId"
    | "/app/operator/routing/"
    | "/app/operator/servers/"
    | "/app/operator/tenants/"
    | "/app/operator/routing/nodes/$nodeId"
    | "/app/operator/routing/nodes/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  PricingRoute: typeof PricingRoute
  PrivacyRoute: typeof PrivacyRoute
  RankRoute: typeof RankRoute
  TermsRoute: typeof TermsRoute
  MSplatRoute: typeof MSplatRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/app": {
      id: "/app"
      path: "/app"
      fullPath: "/app"
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/pricing": {
      id: "/pricing"
      path: "/pricing"
      fullPath: "/pricing"
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/privacy": {
      id: "/privacy"
      path: "/privacy"
      fullPath: "/privacy"
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/rank": {
      id: "/rank"
      path: "/rank"
      fullPath: "/rank"
      preLoaderRoute: typeof RankRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/terms": {
      id: "/terms"
      path: "/terms"
      fullPath: "/terms"
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/app/": {
      id: "/app/"
      path: "/"
      fullPath: "/app/"
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/$": {
      id: "/app/$"
      path: "/$"
      fullPath: "/app/$"
      preLoaderRoute: typeof AppSplatRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/dashboard": {
      id: "/app/dashboard"
      path: "/dashboard"
      fullPath: "/app/dashboard"
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/forbidden": {
      id: "/app/forbidden"
      path: "/forbidden"
      fullPath: "/app/forbidden"
      preLoaderRoute: typeof AppForbiddenRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/nodes": {
      id: "/app/nodes"
      path: "/nodes"
      fullPath: "/app/nodes"
      preLoaderRoute: typeof AppNodesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/operator": {
      id: "/app/operator"
      path: "/operator"
      fullPath: "/app/operator"
      preLoaderRoute: typeof AppOperatorRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/settings": {
      id: "/app/settings"
      path: "/settings"
      fullPath: "/app/settings"
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/tenant": {
      id: "/app/tenant"
      path: "/tenant"
      fullPath: "/app/tenant"
      preLoaderRoute: typeof AppTenantRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/traffic": {
      id: "/app/traffic"
      path: "/traffic"
      fullPath: "/app/traffic"
      preLoaderRoute: typeof AppTrafficRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/m/$": {
      id: "/m/$"
      path: "/m/$"
      fullPath: "/m/$"
      preLoaderRoute: typeof MSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/app/me/credentials": {
      id: "/app/me/credentials"
      path: "/me/credentials"
      fullPath: "/app/me/credentials"
      preLoaderRoute: typeof AppMeCredentialsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/me/nodes": {
      id: "/app/me/nodes"
      path: "/me/nodes"
      fullPath: "/app/me/nodes"
      preLoaderRoute: typeof AppMeNodesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/me/notifications": {
      id: "/app/me/notifications"
      path: "/me/notifications"
      fullPath: "/app/me/notifications"
      preLoaderRoute: typeof AppMeNotificationsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/me/settings": {
      id: "/app/me/settings"
      path: "/me/settings"
      fullPath: "/app/me/settings"
      preLoaderRoute: typeof AppMeSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/me/subscriptions": {
      id: "/app/me/subscriptions"
      path: "/me/subscriptions"
      fullPath: "/app/me/subscriptions"
      preLoaderRoute: typeof AppMeSubscriptionsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/me/usage": {
      id: "/app/me/usage"
      path: "/me/usage"
      fullPath: "/app/me/usage"
      preLoaderRoute: typeof AppMeUsageRouteImport
      parentRoute: typeof AppRouteRoute
    }
    "/app/operator/": {
      id: "/app/operator/"
      path: "/"
      fullPath: "/app/operator/"
      preLoaderRoute: typeof AppOperatorIndexRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/announcements": {
      id: "/app/operator/announcements"
      path: "/announcements"
      fullPath: "/app/operator/announcements"
      preLoaderRoute: typeof AppOperatorAnnouncementsRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/audit-logs": {
      id: "/app/operator/audit-logs"
      path: "/audit-logs"
      fullPath: "/app/operator/audit-logs"
      preLoaderRoute: typeof AppOperatorAuditLogsRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/credential-domains": {
      id: "/app/operator/credential-domains"
      path: "/credential-domains"
      fullPath: "/app/operator/credential-domains"
      preLoaderRoute: typeof AppOperatorCredentialDomainsRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/enrollment-tokens": {
      id: "/app/operator/enrollment-tokens"
      path: "/enrollment-tokens"
      fullPath: "/app/operator/enrollment-tokens"
      preLoaderRoute: typeof AppOperatorEnrollmentTokensRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/external-resources": {
      id: "/app/operator/external-resources"
      path: "/external-resources"
      fullPath: "/app/operator/external-resources"
      preLoaderRoute: typeof AppOperatorExternalResourcesRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/grants": {
      id: "/app/operator/grants"
      path: "/grants"
      fullPath: "/app/operator/grants"
      preLoaderRoute: typeof AppOperatorGrantsRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/node-groups": {
      id: "/app/operator/node-groups"
      path: "/node-groups"
      fullPath: "/app/operator/node-groups"
      preLoaderRoute: typeof AppOperatorNodeGroupsRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/node-instances": {
      id: "/app/operator/node-instances"
      path: "/node-instances"
      fullPath: "/app/operator/node-instances"
      preLoaderRoute: typeof AppOperatorNodeInstancesRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/nodes": {
      id: "/app/operator/nodes"
      path: "/nodes"
      fullPath: "/app/operator/nodes"
      preLoaderRoute: typeof AppOperatorNodesRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/packages": {
      id: "/app/operator/packages"
      path: "/packages"
      fullPath: "/app/operator/packages"
      preLoaderRoute: typeof AppOperatorPackagesRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/traffic": {
      id: "/app/operator/traffic"
      path: "/traffic"
      fullPath: "/app/operator/traffic"
      preLoaderRoute: typeof AppOperatorTrafficRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/users": {
      id: "/app/operator/users"
      path: "/users"
      fullPath: "/app/operator/users"
      preLoaderRoute: typeof AppOperatorUsersRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/tenant/": {
      id: "/app/tenant/"
      path: "/"
      fullPath: "/app/tenant/"
      preLoaderRoute: typeof AppTenantIndexRouteImport
      parentRoute: typeof AppTenantRouteRoute
    }
    "/app/tenant/links": {
      id: "/app/tenant/links"
      path: "/links"
      fullPath: "/app/tenant/links"
      preLoaderRoute: typeof AppTenantLinksRouteImport
      parentRoute: typeof AppTenantRouteRoute
    }
    "/app/tenant/node-groups": {
      id: "/app/tenant/node-groups"
      path: "/node-groups"
      fullPath: "/app/tenant/node-groups"
      preLoaderRoute: typeof AppTenantNodeGroupsRouteImport
      parentRoute: typeof AppTenantRouteRoute
    }
    "/app/tenant/packages": {
      id: "/app/tenant/packages"
      path: "/packages"
      fullPath: "/app/tenant/packages"
      preLoaderRoute: typeof AppTenantPackagesRouteImport
      parentRoute: typeof AppTenantRouteRoute
    }
    "/app/tenant/subscriptions": {
      id: "/app/tenant/subscriptions"
      path: "/subscriptions"
      fullPath: "/app/tenant/subscriptions"
      preLoaderRoute: typeof AppTenantSubscriptionsRouteImport
      parentRoute: typeof AppTenantRouteRoute
    }
    "/app/tenant/usage": {
      id: "/app/tenant/usage"
      path: "/usage"
      fullPath: "/app/tenant/usage"
      preLoaderRoute: typeof AppTenantUsageRouteImport
      parentRoute: typeof AppTenantRouteRoute
    }
    "/app/tenant/users": {
      id: "/app/tenant/users"
      path: "/users"
      fullPath: "/app/tenant/users"
      preLoaderRoute: typeof AppTenantUsersRouteImport
      parentRoute: typeof AppTenantRouteRoute
    }
    "/app/operator/routing/": {
      id: "/app/operator/routing/"
      path: "/routing"
      fullPath: "/app/operator/routing/"
      preLoaderRoute: typeof AppOperatorRoutingIndexRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/routing/global": {
      id: "/app/operator/routing/global"
      path: "/routing/global"
      fullPath: "/app/operator/routing/global"
      preLoaderRoute: typeof AppOperatorRoutingGlobalRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/routing/reject-lists": {
      id: "/app/operator/routing/reject-lists"
      path: "/routing/reject-lists"
      fullPath: "/app/operator/routing/reject-lists"
      preLoaderRoute: typeof AppOperatorRoutingRejectListsRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/routing/users": {
      id: "/app/operator/routing/users"
      path: "/routing/users"
      fullPath: "/app/operator/routing/users"
      preLoaderRoute: typeof AppOperatorRoutingUsersRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/servers/": {
      id: "/app/operator/servers/"
      path: "/servers"
      fullPath: "/app/operator/servers/"
      preLoaderRoute: typeof AppOperatorServersIndexRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/servers/$serverId": {
      id: "/app/operator/servers/$serverId"
      path: "/servers/$serverId"
      fullPath: "/app/operator/servers/$serverId"
      preLoaderRoute: typeof AppOperatorServersServerIdRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/tenants/": {
      id: "/app/operator/tenants/"
      path: "/tenants"
      fullPath: "/app/operator/tenants/"
      preLoaderRoute: typeof AppOperatorTenantsIndexRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/tenants/$tenantId": {
      id: "/app/operator/tenants/$tenantId"
      path: "/tenants/$tenantId"
      fullPath: "/app/operator/tenants/$tenantId"
      preLoaderRoute: typeof AppOperatorTenantsTenantIdRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/routing/nodes/": {
      id: "/app/operator/routing/nodes/"
      path: "/routing/nodes"
      fullPath: "/app/operator/routing/nodes/"
      preLoaderRoute: typeof AppOperatorRoutingNodesIndexRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
    "/app/operator/routing/nodes/$nodeId": {
      id: "/app/operator/routing/nodes/$nodeId"
      path: "/routing/nodes/$nodeId"
      fullPath: "/app/operator/routing/nodes/$nodeId"
      preLoaderRoute: typeof AppOperatorRoutingNodesNodeIdRouteImport
      parentRoute: typeof AppOperatorRouteRoute
    }
  }
}

interface AppOperatorRouteRouteChildren {
  AppOperatorAnnouncementsRoute: typeof AppOperatorAnnouncementsRoute
  AppOperatorAuditLogsRoute: typeof AppOperatorAuditLogsRoute
  AppOperatorCredentialDomainsRoute: typeof AppOperatorCredentialDomainsRoute
  AppOperatorEnrollmentTokensRoute: typeof AppOperatorEnrollmentTokensRoute
  AppOperatorExternalResourcesRoute: typeof AppOperatorExternalResourcesRoute
  AppOperatorGrantsRoute: typeof AppOperatorGrantsRoute
  AppOperatorNodeGroupsRoute: typeof AppOperatorNodeGroupsRoute
  AppOperatorNodeInstancesRoute: typeof AppOperatorNodeInstancesRoute
  AppOperatorNodesRoute: typeof AppOperatorNodesRoute
  AppOperatorPackagesRoute: typeof AppOperatorPackagesRoute
  AppOperatorTrafficRoute: typeof AppOperatorTrafficRoute
  AppOperatorUsersRoute: typeof AppOperatorUsersRoute
  AppOperatorIndexRoute: typeof AppOperatorIndexRoute
  AppOperatorRoutingGlobalRoute: typeof AppOperatorRoutingGlobalRoute
  AppOperatorRoutingRejectListsRoute: typeof AppOperatorRoutingRejectListsRoute
  AppOperatorRoutingUsersRoute: typeof AppOperatorRoutingUsersRoute
  AppOperatorServersServerIdRoute: typeof AppOperatorServersServerIdRoute
  AppOperatorTenantsTenantIdRoute: typeof AppOperatorTenantsTenantIdRoute
  AppOperatorRoutingIndexRoute: typeof AppOperatorRoutingIndexRoute
  AppOperatorServersIndexRoute: typeof AppOperatorServersIndexRoute
  AppOperatorTenantsIndexRoute: typeof AppOperatorTenantsIndexRoute
  AppOperatorRoutingNodesNodeIdRoute: typeof AppOperatorRoutingNodesNodeIdRoute
  AppOperatorRoutingNodesIndexRoute: typeof AppOperatorRoutingNodesIndexRoute
}

const AppOperatorRouteRouteChildren: AppOperatorRouteRouteChildren = {
  AppOperatorAnnouncementsRoute: AppOperatorAnnouncementsRoute,
  AppOperatorAuditLogsRoute: AppOperatorAuditLogsRoute,
  AppOperatorCredentialDomainsRoute: AppOperatorCredentialDomainsRoute,
  AppOperatorEnrollmentTokensRoute: AppOperatorEnrollmentTokensRoute,
  AppOperatorExternalResourcesRoute: AppOperatorExternalResourcesRoute,
  AppOperatorGrantsRoute: AppOperatorGrantsRoute,
  AppOperatorNodeGroupsRoute: AppOperatorNodeGroupsRoute,
  AppOperatorNodeInstancesRoute: AppOperatorNodeInstancesRoute,
  AppOperatorNodesRoute: AppOperatorNodesRoute,
  AppOperatorPackagesRoute: AppOperatorPackagesRoute,
  AppOperatorTrafficRoute: AppOperatorTrafficRoute,
  AppOperatorUsersRoute: AppOperatorUsersRoute,
  AppOperatorIndexRoute: AppOperatorIndexRoute,
  AppOperatorRoutingGlobalRoute: AppOperatorRoutingGlobalRoute,
  AppOperatorRoutingRejectListsRoute: AppOperatorRoutingRejectListsRoute,
  AppOperatorRoutingUsersRoute: AppOperatorRoutingUsersRoute,
  AppOperatorServersServerIdRoute: AppOperatorServersServerIdRoute,
  AppOperatorTenantsTenantIdRoute: AppOperatorTenantsTenantIdRoute,
  AppOperatorRoutingIndexRoute: AppOperatorRoutingIndexRoute,
  AppOperatorServersIndexRoute: AppOperatorServersIndexRoute,
  AppOperatorTenantsIndexRoute: AppOperatorTenantsIndexRoute,
  AppOperatorRoutingNodesNodeIdRoute: AppOperatorRoutingNodesNodeIdRoute,
  AppOperatorRoutingNodesIndexRoute: AppOperatorRoutingNodesIndexRoute,
}

const AppOperatorRouteRouteWithChildren =
  AppOperatorRouteRoute._addFileChildren(AppOperatorRouteRouteChildren)

interface AppTenantRouteRouteChildren {
  AppTenantLinksRoute: typeof AppTenantLinksRoute
  AppTenantNodeGroupsRoute: typeof AppTenantNodeGroupsRoute
  AppTenantPackagesRoute: typeof AppTenantPackagesRoute
  AppTenantSubscriptionsRoute: typeof AppTenantSubscriptionsRoute
  AppTenantUsageRoute: typeof AppTenantUsageRoute
  AppTenantUsersRoute: typeof AppTenantUsersRoute
  AppTenantIndexRoute: typeof AppTenantIndexRoute
}

const AppTenantRouteRouteChildren: AppTenantRouteRouteChildren = {
  AppTenantLinksRoute: AppTenantLinksRoute,
  AppTenantNodeGroupsRoute: AppTenantNodeGroupsRoute,
  AppTenantPackagesRoute: AppTenantPackagesRoute,
  AppTenantSubscriptionsRoute: AppTenantSubscriptionsRoute,
  AppTenantUsageRoute: AppTenantUsageRoute,
  AppTenantUsersRoute: AppTenantUsersRoute,
  AppTenantIndexRoute: AppTenantIndexRoute,
}

const AppTenantRouteRouteWithChildren = AppTenantRouteRoute._addFileChildren(
  AppTenantRouteRouteChildren,
)

interface AppRouteRouteChildren {
  AppOperatorRouteRoute: typeof AppOperatorRouteRouteWithChildren
  AppTenantRouteRoute: typeof AppTenantRouteRouteWithChildren
  AppSplatRoute: typeof AppSplatRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppForbiddenRoute: typeof AppForbiddenRoute
  AppNodesRoute: typeof AppNodesRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTrafficRoute: typeof AppTrafficRoute
  AppIndexRoute: typeof AppIndexRoute
  AppMeCredentialsRoute: typeof AppMeCredentialsRoute
  AppMeNodesRoute: typeof AppMeNodesRoute
  AppMeNotificationsRoute: typeof AppMeNotificationsRoute
  AppMeSettingsRoute: typeof AppMeSettingsRoute
  AppMeSubscriptionsRoute: typeof AppMeSubscriptionsRoute
  AppMeUsageRoute: typeof AppMeUsageRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppOperatorRouteRoute: AppOperatorRouteRouteWithChildren,
  AppTenantRouteRoute: AppTenantRouteRouteWithChildren,
  AppSplatRoute: AppSplatRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppForbiddenRoute: AppForbiddenRoute,
  AppNodesRoute: AppNodesRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTrafficRoute: AppTrafficRoute,
  AppIndexRoute: AppIndexRoute,
  AppMeCredentialsRoute: AppMeCredentialsRoute,
  AppMeNodesRoute: AppMeNodesRoute,
  AppMeNotificationsRoute: AppMeNotificationsRoute,
  AppMeSettingsRoute: AppMeSettingsRoute,
  AppMeSubscriptionsRoute: AppMeSubscriptionsRoute,
  AppMeUsageRoute: AppMeUsageRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  PricingRoute: PricingRoute,
  PrivacyRoute: PrivacyRoute,
  RankRoute: RankRoute,
  TermsRoute: TermsRoute,
  MSplatRoute: MSplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
